"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var owa_strings_1 = require("owa-strings");
function numberToByteQuantifiedStringConverter(bytes) {
    var formatString;
    if (bytes >= 0x40000000) {
        // GB
        bytes /= 0x40000000;
        formatString = owa_mail_strings_1.default.sizeWithGigabyteAbbreviationText;
    }
    else if (bytes >= 0x100000) {
        // MB
        bytes /= 0x100000;
        formatString = owa_mail_strings_1.default.sizeWithMegabyteAbbreviationText;
    }
    else if (bytes >= 0x400) {
        // KB
        bytes /= 0x400;
        formatString = owa_mail_strings_1.default.sizeWithKilobyteAbbreviationText;
    }
    else {
        formatString = owa_mail_strings_1.default.sizeWithByteAbbreviationText;
    }
    return owa_strings_1.format(formatString, Math.round(bytes));
}
exports.default = numberToByteQuantifiedStringConverter;
//# sourceMappingURL=numberToByteQuantifiedStringConverter.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/attachments/owa-file-common/lib/utils/numberToByteQuantifiedStringConverter.js
// module id = 1578
// module chunks = 0 1 11 13 24 43 84 100 106 107